function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $props, $setup, setupComponent, createComponent } from "@opentiny/vue-common";
import { MsgQueue } from "@opentiny/vue-renderless/modal";
import PcTemplate from "./pc.js";
import MobileTemplate from "./mobile.js";
import MobileFirstTemplate from "./mobile-first.js";
var template = function template2(mode) {
  if ("pc" === (process.env.TINY_MODE || mode)) {
    return PcTemplate;
  }
  if ("mobile" === (process.env.TINY_MODE || mode)) {
    return MobileTemplate;
  }
  if ("mobile-first" === (process.env.TINY_MODE || mode)) {
    return MobileFirstTemplate;
  }
  return PcTemplate;
};
var $constants = {
  MODAL_STATUS: {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    LOADING: "loading"
  },
  NODAL_TYPE: {
    ALERT: "alert",
    CONFIRM: "confirm",
    MESSAGE: "message"
  },
  STATUS_MAPPING_CLASSS: {
    INFO: "tiny-modal-svg__info",
    SUCCESS: "tiny-modal-svg__success",
    WARNING: "tiny-modal-svg__warning",
    ERROR: "tiny-modal-svg__error",
    LOADING: "tiny-modal-svg__refresh roll"
  }
};
var TINYModal = defineComponent({
  name: $prefix + "Modal",
  componentName: "Modal",
  props: _extends({}, $props, {
    _constants: {
      type: Object,
      default: function _default() {
        return $constants;
      }
    },
    animat: {
      type: Boolean,
      default: function _default2() {
        return true;
      }
    },
    beforeClose: Function,
    duration: {
      type: [Number, String],
      default: function _default3() {
        return 3e3;
      }
    },
    escClosable: Boolean,
    events: Object,
    fullscreen: Boolean,
    height: [Number, String],
    id: String,
    isFormReset: {
      type: Boolean,
      default: true
    },
    lockScroll: Boolean,
    lockView: {
      type: Boolean,
      default: function _default4() {
        return true;
      }
    },
    marginSize: {
      type: [Number, String],
      default: 10
    },
    mask: {
      type: Boolean,
      default: function _default5() {
        return true;
      }
    },
    maskClosable: Boolean,
    message: [String, Function, Object],
    minHeight: {
      type: [Number, String],
      default: function _default6() {
        return 200;
      }
    },
    minWidth: {
      type: [Number, String],
      default: function _default7() {
        return 340;
      }
    },
    modelValue: Boolean,
    resize: Boolean,
    showFooter: Boolean,
    showHeader: {
      type: Boolean,
      default: true
    },
    status: {
      type: [String, Object],
      default: ""
    },
    title: String,
    top: {
      type: [Number, String],
      default: 15
    },
    type: {
      type: String,
      default: "alert"
    },
    vSize: String,
    width: [Number, String],
    zIndex: [Number, String],
    tiny_theme: String,
    mode: null,
    description: String,
    options: Array,
    showClose: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: "",
      validator: function validator(val) {
        return ["", "bottom-right"].includes(val);
      }
    },
    modalBoxClass: String,
    confirmContent: String,
    cancelContent: String,
    confirmBtnProps: {
      type: Object,
      default: function _default8() {
        return {};
      }
    },
    cancelBtnProps: {
      type: Object,
      default: function _default9() {
        return {};
      }
    }
  }),
  setup: function setup(props, context) {
    return $setup({
      props,
      context,
      template
    });
  }
});
var version = "2.10.0";
TINYModal.version = version;
TINYModal.model = {
  prop: "modelValue",
  event: "update:modelValue"
};
function Modal(options) {
  var modalPromise = new Promise(function(resolve) {
    if (options && options.id && MsgQueue.some(function(comp) {
      return comp.id === options.id;
    })) {
      resolve("exist");
    } else {
      var events = options.events || {};
      var $modal;
      options.events = _extends({}, events, {
        hide: function hide(params) {
          events.hide && events.hide.call(this, params);
          $modal.beforeUnmouted();
          resolve(params.type);
        }
      });
      $modal = createComponent({
        el: document.createElement("div"),
        propsData: options,
        component: TINYModal
      });
      $modal.open();
      setTimeout(function() {
        return modalPromise.vm = $modal;
      }, 0);
    }
  });
  return modalPromise;
}
var modal = Modal;
var types = ["alert", "confirm", "message"];
types.forEach(function(type, index) {
  var defOpts = {
    showFooter: true
  };
  if (index === 2) {
    defOpts = {
      mask: false,
      lockView: false,
      showHeader: false,
      showClose: false
    };
  }
  defOpts.type = type;
  if (index === 1) {
    defOpts.status = "question";
  }
  TINYModal[type] = Modal[type] = function(message2, title, options) {
    var opts;
    if (typeof message2 === "object" && message2 !== null) {
      opts = message2;
    } else if (title) {
      opts = {
        title
      };
    }
    if (message2 === void 0 || message2 === null) {
      message2 = "";
    }
    return modal(_extends({
      message: message2.toString(),
      type
    }, defOpts, opts, options));
  };
});
var alert = Modal.alert;
var message = Modal.message;
var confirm = Modal.confirm;
TINYModal.installed = false;
setupComponent.TINYModal = {
  install: function install(Vue) {
    if (TINYModal.installed)
      return;
    var isVue2 = !!Vue.component;
    var tinyMode = isVue2 ? Vue.prototype.tiny_mode : Vue.config.globalProperties.tiny_mode;
    var tinyTheme = isVue2 ? Vue.prototype.tiny_theme : Vue.config.globalProperties.tiny_theme;
    TINYModal.tiny_mode = process.env.TINY_MODE || tinyMode && tinyMode.value;
    TINYModal.tiny_theme = tinyTheme && tinyTheme.value;
    TINYModal.installed = true;
  },
  init: function init(root) {
    var prefix = root.$TinyModalApiPrefix || "$";
    root[prefix + "alert"] = Modal.alert;
    root[prefix + "message"] = Modal.message;
    root[prefix + "confirm"] = Modal.confirm;
  }
};
TINYModal.install = function(Vue) {
  Vue.component(TINYModal.name, TINYModal);
};
export {
  Modal,
  alert,
  confirm,
  TINYModal as default,
  message
};
